import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../config";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${BACKEND_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || "User not found");
      }
      setMessage("Reset link has been sent to your email");
    } catch (err) {
      setError(err.message || "User not found");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md bg-white/10 border border-white/10 rounded-3xl p-8 backdrop-blur shadow-2xl">
        <h1 className="text-3xl font-semibold text-center mb-6">Forgot Password</h1>
        <p className="text-center text-white/70 text-sm mb-8">
          Enter your email address and we’ll send you a link to reset your password.
        </p>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="text-sm font-medium text-white/80">Email</label>
            <input
              type="email"
              required
              className="w-full bg-white/10 border border-white/20 rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-300 text-white placeholder-white/50"
              placeholder="name@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {message && (
            <div className="text-emerald-200 bg-emerald-500/20 border border-emerald-400/40 rounded-xl px-4 py-3 text-sm">
              {message}
            </div>
          )}

          {error && (
            <div className="text-rose-200 bg-rose-500/20 border border-rose-400/40 rounded-xl px-4 py-3 text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-2xl bg-gradient-to-r from-blue-500 to-indigo-500 font-semibold text-white shadow-lg shadow-blue-500/40 hover:opacity-95 transition disabled:opacity-60"
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          <button
            type="button"
            className="w-full text-center text-sm text-white/70 hover:text-white mt-4"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
}
